import { render, staticRenderFns } from "./Schoolyear.vue?vue&type=template&id=42fa6390"
import script from "./Schoolyear.vue?vue&type=script&lang=js"
export * from "./Schoolyear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports